import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { Nullable } from '@/interfaces/Nullable';
import formatNumber from '@/utils/formatNumber';
import styles from './CashbackEstimation.module.scss';

interface Props {
  cashbackEstimate: Nullable<string>;
}

const CashbackEstimation = ({ cashbackEstimate }: Props) => {
  const { currencySymbol } = useCurrency();
  if (cashbackEstimate === '0') return null;

  return (
    <>
      <div className={styles.root}>
        <div className={styles.cashbackEstimate}>
          {currencySymbol} <span>{formatNumber(cashbackEstimate || '0')}</span>
        </div>
      </div>
    </>
  );
};

export default CashbackEstimation;
